import { useEffect, useRef, useState } from 'react';

// Petit sélecteur d'emojis (sans dépendance). Appelle onSelect(emoji) au clic.
const EMOJIS = [
  '😀', '😃', '😄', '😁', '😆', '😅', '😂', '🤣',
  '🙂', '😊', '😍', '🥰', '😎', '🤩', '🥳', '😉',
  '😌', '🤔', '😐', '😴', '😢', '😭', '😡', '🤯',
  '👍', '👎', '👏', '🙏', '💪', '🙌', '🤝', '👌',
  '🔥', '⭐', '🌟', '✨', '💯', '✅', '🎉', '🚀',
  '❤️', '🧡', '💛', '💚', '💙', '💜', '🎮', '🏆',
];

function EmojiPicker({ onSelect }) {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    if (!open) return undefined;
    const onDoc = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener('mousedown', onDoc);
    return () => document.removeEventListener('mousedown', onDoc);
  }, [open]);

  return (
    <div className="emojipick" ref={ref}>
      <button
        type="button"
        className="emojipick__btn"
        onClick={() => setOpen((v) => !v)}
        aria-label="Emoji"
        title="Emoji"
      >
        😊
      </button>
      {open && (
        <div className="emojipick__pop" role="menu">
          {EMOJIS.map((e) => (
            <button
              key={e}
              type="button"
              className="emojipick__emoji"
              onClick={() => {
                onSelect(e);
                setOpen(false);
              }}
            >
              {e}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}

export default EmojiPicker;
